import { render } from "./WhitelistView.vue?vue&type=template&id=0fa51a0a&scoped=true"
import script from "./WhitelistView.vue?vue&type=script&lang=js"
export * from "./WhitelistView.vue?vue&type=script&lang=js"

import "./WhitelistView.vue?vue&type=style&index=0&id=0fa51a0a&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa51a0a"]])

export default __exports__